module.exports = __webpack_public_path__ + "img/img21.530ca899.png";